import { render, staticRenderFns } from "./QueryExam.vue?vue&type=template&id=56fae790&scoped=true"
import script from "./QueryExam.vue?vue&type=script&lang=js"
export * from "./QueryExam.vue?vue&type=script&lang=js"
import style0 from "./QueryExam.vue?vue&type=style&index=0&id=56fae790&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fae790",
  null
  
)

export default component.exports